import type { FC } from 'react';
import { QText } from '../../../QAtoms';
import { usePaginationMaybe } from '../Pagination/context';
import { useDataCount } from './hooks/useDataCount';
import { useLibraryTranslation } from '../../../i18n';

const FormatNumber = new Intl.NumberFormat();

export const ItemCount: FC = () => {
  const pagination = usePaginationMaybe();
  const { count, isLoading } = useDataCount();
  const { t } = useLibraryTranslation();

  if (isLoading) {
    return null;
  }

  // If we have pagination context, use the original pagination logic
  if (pagination?.itemCount) {
    const { itemCount, pageCount, pageSize } = pagination;
    const shouldShowExactCount =
      pageCount || (itemCount ?? Infinity) < pageSize;

    if (shouldShowExactCount) {
      return (
        <QText fontSize="sm" fontWeight={600} data-cy="item-count">
          {FormatNumber.format(itemCount)}{' '}
          {t('table.item', { count: itemCount })}
        </QText>
      );
    }

    return itemCount ? (
      <QText fontSize="sm" fontWeight={600} data-cy="item-count">
        {FormatNumber.format(
          Math.floor(itemCount / (itemCount > 200 ? 100 : 10)) * 10,
        )}{' '}
        {t('table.approximateItems')}
      </QText>
    ) : null;
  }

  // For non-paginated cases, always show exact count
  if (count) {
    return (
      <QText fontSize="sm" fontWeight={600} data-cy="item-count">
        {FormatNumber.format(count)} {t('table.item', { count })}
      </QText>
    );
  }

  return null;
};
